import {withRouter} from "react-router-dom";
import {Col, Container, Row} from "react-bootstrap";
import {trans} from "../../helpers/HelperGlobal";
import {faComments} from "@fortawesome/free-regular-svg-icons";
import {faAt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import UserInfo from "../auth/UserInfo";

const Footer = () => {
    return (
        <footer className={"mt-4"}>
            <div style={{display: "flex", justifyContent: "center"}}>
                <Container>
                    <Row>
                        <Col xs={12} lg={4} className={"mb-2"}>
                            <Container className={'p-0'}>
                                <Row>
                                    <Col xs={12} lg={'auto'}>
                                        <ul className={"left"}>
                                            <li>
                                                <a href={"/about"}>Hakkımızda</a>
                                            </li>
                                            <li>
                                                <a href={UserInfo.info('user_roles_id') === 3 ? '/dokumanlar/sss' : "/faq"}>SSS</a>
                                            </li>
                                            <li>
                                                <a href={"/kvkk-aydinlatma-metni"}>KVKK Aydınlatma Metni</a>
                                            </li>
                                            <li>
                                                <a href={"/acik-riza-beyani"}>Açık Rıza Beyanı</a>
                                            </li>
                                        </ul>
                                    </Col>
                                    <Col xs={12} lg={true}>
                                        <div className={'warning-div'}>
                                            <span className={'mb-2 warning-title'}>ÖNEMLİ UYARI</span>
                                            <span className={'mb-2'}>Bu sitedeki bilgiler hekim veya eczacıya danışma yerine geçmez.</span>
                                            <div className={'d-flex flex-row align-items-center justify-content-start'}>
                                                <img
                                                    src={require("../../assets/images/png/alyors_logo.png")}
                                                    width={90}
                                                    alt={'alyors'}
                                                />
                                                <span className={'ms-1'}>iştirakidir.</span>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                        <Col xs={12} lg={4} className={"mb-4 p-0"}>
                            <div className={"copyright d-flex align-items-center justify-content-lg-center justify-content-center"}>
                                <div className={"middle social-media container"}>
                                    <div className={"row p-0 m-0"}>
                                        <div
                                            className={"col-12 p-0 m-0 mb-2 d-flex align-items-center justify-content-center"}
                                            style={{height: 100}}
                                        >
                                            <img
                                                src={require('../../assets/images/png/theme/SHINIQ_Logo.png')}
                                                className={"img-fluid"}
                                                style={{height: 100}}
                                            />
                                        </div>
                                        <div className={"col-12 p-0 m-0 d-flex align-items-center justify-content-center gap-2"}>
                                            <a
                                                href={"https://www.instagram.com/ShiniqTurkiye/"}
                                                target={"_blank"}
                                            >
                                                <img
                                                    src={require("../../assets/images/png/icons/instagram_icon.png")}
                                                    width={20}
                                                    alt={trans("title")}
                                                />
                                            </a>
                                            <a
                                                href={"https://www.youtube.com/@ShiniqTurkiye"}
                                                target={"_blank"}
                                            >
                                                <img
                                                    src={require("../../assets/images/png/icons/youtube_icon.png")}
                                                    width={22}
                                                    alt={trans("title")}
                                                />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} lg={4} className={"mb-2"}>
                            <div className={'d-flex justify-content-center align-items-center w-100 h-100'}>
                                <div className={"footer-new col-md-6"}>
                                    <div>
                                        <FontAwesomeIcon
                                            icon={faAt}
                                            style={{
                                                fontSize: "30px",
                                                paddingBottom: "7px",
                                            }}
                                        />
                                    </div>
                                    <div>E-Posta Adresimiz</div>
                                    <div>
                                        <a href={"mailto:info@shiniq.com"}>
                                            info@shiniq.com
                                        </a>
                                    </div>
                                </div>

                                <div className={"footer-new col-md-6"}>
                                    <div>
                                        <FontAwesomeIcon
                                            icon={faComments}
                                            style={{
                                                fontSize: "30px",
                                                paddingBottom: "7px",
                                            }}
                                        />
                                    </div>
                                    <div>Bize Yazın</div>
                                    <div>
                                        <a href={"/contact"}>İletişim</a>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Container>
                <Row>
                    <div className={"innthebox-new copyright mb-3 d-flex align-items-center justify-content-lg-center justify-content-center"}>
                        <img
                            src={require("../../assets/images/png/innthebox-logo.png")}
                        />
                    </div>
                </Row>
                <Row>
                    <div className={"copyright mb-4 d-flex align-items-center justify-content-lg-center justify-content-center"}>
                        <span>
                            {" "}
                            Copyright {new Date().getFullYear()} © SHINIQ Portal
                        </span>
                    </div>
                </Row>
            </Container>
        </footer>
    );
};

export default withRouter(Footer);
